module.exports = __webpack_public_path__ + "static/media/DarkService.2c944d28.svg";